import { EImportFileType } from 'core/model/enums';
import type { IGetUploadFileResponse } from 'core/model/interfaces/downloads-uploads';
import { https, httpsMultipart } from 'shared/utils/https';
import type { IGetUploadByFileTypeDTO } from '../downloads-uploads/uploads.dto';
import type {
  IGetBranchesListParams,
  IGetBranchesListResponse,
  IGetBranchExclusionParamsDTO,
  IToggleBranchCreditParamsDTO,
  IToggleBranchPurchaseLimitParamsDTO,
  IUpdateBranchParamsDTO,
} from './branches.dto';

const branchesApiVersion = 'v1';

const branchesBaseURL = `/${branchesApiVersion}/distributors`;

export const branchesData = {
  getBranches: async (params: IGetBranchesListParams): Promise<IGetBranchesListResponse> => {
    const { subject, query, ...rest } = params;

    const { data } = await https.get<IGetBranchesListResponse>(`${branchesBaseURL}/branches`, {
      headers: {
        'Gtm-Operator-Id': subject || '',
      },
      params: { ...rest, name: query },
    });

    return data;
  },
  updateBranch: async (params: IUpdateBranchParamsDTO) => {
    const { branchId, distributorId, ...body } = params;

    const url = `${branchesBaseURL}/${distributorId}/branches/${branchId}`;

    const { data } = await https.patch(url, body);

    return data;
  },
  toggleBranchPurchaseLimit: async (params: IToggleBranchPurchaseLimitParamsDTO) => {
    const { branchId, distributorId, ...body } = params;

    const url = `${branchesBaseURL}/${distributorId}/branches/${branchId}`;

    const { data } = await https.patch(url, body);

    return data;
  },
  toggleBranchCredit: async (params: IToggleBranchCreditParamsDTO) => {
    const { branchId, distributorId, ...body } = params;

    const url = `${branchesBaseURL}/${distributorId}/branches/${branchId}`;

    const { data } = await https.patch(url, body);

    return data;
  },
  getBranchCustomersExclusion: async (params: IGetBranchExclusionParamsDTO) => {
    const { channel } = params;

    const url = `${branchesApiVersion}/channels/${channel}/customers/attributes/imports/latest`;

    const { data } = await https.get<IGetUploadByFileTypeDTO>(url, {
      params: { fileType: EImportFileType.EXCLUDE_CREDIT },
    });

    return data;
  },
  upsertBranchCustomersExclusion: async (params: IGetBranchExclusionParamsDTO, formData: FormData) => {
    const { channel } = params;

    const url = `${branchesApiVersion}/channels/${channel}/customers/attributes/imports`;

    const { data } = await httpsMultipart.post<IGetUploadFileResponse>(url, formData);

    return data;
  },
};
